import { action, makeObservable, observable } from 'mobx';

export class MultichoiceManager {
  constructor() {
    makeObservable(this);
  }

  @observable multichoiceItems = new Map();

  @action setMultichoiceItems(id, items) {
    this.multichoiceItems.set(id, items);
  }

  @action getMultichoiceItems(id) {
    return this.multichoiceItems.get(id);
  }

  @action hasMultichoiceItems(id) {
    return this.multichoiceItems.has(id);
  }

  @action clearMultichoiceItems() {
    this.multichoiceItems.clear();
  }
}

export default new MultichoiceManager();
